import React, { useState, useRef } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';

const KeyMessages = () => {
  return (
    <section className="l-sec">
      <div className="background_">
        <img src="img/Photo3.jpg" alt="background"></img>
        <div className="background_grad"></div>
      </div>
      <div className="key-messages">
        <h4>Key Messages</h4>
        <Swiper
          navigation={true}
          modules={[Navigation]}
          className="keySwiper"
        >
          <SwiperSlide>
            <h3>Technology for Good: How Innovation and Open Data Can Deliver Ocean Action</h3>
            <Swiper
              slidesPerView={1}
              className="childSwiper"
              breakpoints={{
                600:{
                  slidesPerView: 2,
                },
                900:{
                  slidesPerView: 3,
                  allowTouchMove: true,
                },
              }}
            >
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/TonyLongCEOofGlobalFishingWatch.png" alt="Tony Long"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>Collaborative partnerships, political will and open data can drive tangible impact and help deliver lasting results for a sustainable ocean future for all.</p>
                  <p>Tony Long, CEO of Global Fishing Watch</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/Dr.PetrosVarelidisSecretaryGeneraloftheGreekMinistryofEnvironmentandEnergy.png" alt="Dr.Petros Varelidis"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>Greece commits to establishing a scientific monitoring and surveillance system for all its marine protected areas. The support of Global Fishing Watch and The Athanasios C. Laskaridis Charitable Foundation will enable us to monitor fishing activity in near real-time.</p>
                  <p> Dr. Petros Varelidis, Secretary General of the Greek Ministry of Environment and Energy</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/ΕύηΛαζούΛασκαρίδη_ΟΟC01.jpg" alt="Εύη Λαζου Λασκαρίδη"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>By fostering strong partnerships among governments, academia, the private sector, and non-profits, we can leverage collective action to enhance data transparency, support research and development, and ultimately uphold our environmental commitments.</p>
                  <p>Evi Lazou-Laskaridis, Chairman of Athanasios C. Laskaridis Charitable Foundation</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </SwiperSlide>
          <SwiperSlide>
            <h3>Marine Litter: Bridging Science and Policy Making</h3>
            <Swiper
              className="childSwiper"
              slidesPerView={1}
              breakpoints={{
                600:{
                  slidesPerView: 2,
                },
                900:{
                  slidesPerView: 3,
                  allowTouchMove: true,
                },
                1200: {
                  slidesPerView: 4,
                  allowTouchMove: false,
                },
              }}
            >
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/ΟΙΚΟΥΜΕΝΙΚΟΣΠΑΤΡΙΑΡΧΗΣΒΑΡΘΟΛΟΜΑΙΟΣ.jpg" alt="Οικουμενικός Πατριάρχης Βαρθολομαίος"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>Once we were few and the sea seemed vast. Today we are many and the sea is at risk. Even the wars that are occuring at this moment in the Middle East, in Northern Africa, as well as in Ukraine, are endagering the balance of our oceans and waterways...We must constantly remember that whatever we do to the oceans, we are doing it to ourselves and ultimately, we are doing it to God. </p>
                  <p>H.A.H Ecumenical Patriarch Bartholomew</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/ΕύηΛαζούΛασκαρίδη_ΟΟC01.jpg" alt="Εύη Λαζου Λασκαρίδη"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>The health of our oceans is linked to the health of our planet and all life upon it. Yet, marine litter threatens to undermine this delicate balance. Insufficiently managed and persistently increasing, marine litter poses grave threats to ecosystems, human health, and the global economy. The problem of the marine pollution is multi-faceted and global and as such it calls for systematic effort, a collaborative mandate. An ecumenical approach also. </p>
                  <p> Evi Lazou-Laskaridis, Chairman of Athanasios C. Laskaridis Charitable Foundation</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/MariaDamanaki,IndependentAdvisoronClimate-Oceans.jpg" alt="Maria Damanaki"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>We are going to create a national plan, and by that I mean an alliance. Not only govermental organizations and public authorities, but also, we create an alliance with great private initiatives, like Athanasios C.Laskaridis Charitable Foundation, and the civil society, the NGO's and the local communities.</p>
                  <p>Maria Damanaki,Independent Advisor on Climate-Oceans, EU Commissioner for Maritime Fisheries (2010-2014), Independent Advisor</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/GeorgePapatheodorou.jpg" alt="George Papatheodorou"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>There is a total lack of good quality of monitoring data, a total lack of certain methods measuring the problem and the level of the pollution. This is a great problem. With one exception: We have the "Typhoon Project". The "Typhoon Project" is the best example of long term and large scaled monitoring project in the Mediterranean Sea, and probably worldwide.</p>
                  <p>George Papatheodorou, Professor, Geology Department and Dean of the School of Natural Sciences, University of Patras</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </SwiperSlide>
          <SwiperSlide>
            <h3>Marine Litter: Bridging Science and Policy Making</h3>
            <Swiper
              slidesPerView={1}
              className="childSwiper"
              breakpoints={{
                600:{
                  slidesPerView: 2,
                },
                900:{
                  slidesPerView: 3,
                  allowTouchMove: true,
                },
              }}
            >
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/CyrillGutsch.jpg" alt="Cyrill Gutsch"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>With our human made technology, with this truly honesty with that arrogance, that ignorance, we are destroying the life support system that allows us to live here. And plastic is a symbol of that. Plastic is a toxic substance that needs to go.</p>
                  <p>Cyrill Gutsch, CEO / Founder, Parley for the Oceans</p>
                </div>
              </SwiperSlide>
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/MaxineBurkett.jpg" alt="Maxine Burkett"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>What inspired my work for years is the phrase "slow as smooth, smooth as fast". In other words, engagement seems slow and arduous and again there are number of people and places to make those connections and ensure public outreaching coordination. But once you have that trust, ultimately success comes quickly.</p>
                  <p> Maxine Burkett, Assistant Director for Climate, Ocean, and Equity at the White House Office</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </SwiperSlide>
          <SwiperSlide>
            <h3>Plenary Session II: Confronting Plastic Pollution</h3>
            <Swiper
              slidesPerView={1}
              className="childSwiper"
            >
              <SwiperSlide className="message">
                <img className="back-circle" src="img/circle.svg" alt="background"></img>
                <img className="message-img" src="img/KeyMessagesPhotos/ΕύηΛαζούΛασκαρίδη_ΟΟC01.jpg" alt="Εύη Λαζου Λασκαρίδη"></img>
                <div className="say-wrapper">
                  <h5>“</h5>
                  <p>All our programs paint a dark picture regarding marine pollution in Greece, similar with that in other areas of the globe. The marine environment is deteriorating fast. Thus, we will keep doing our part and, also, join forces with other stakeholders. What we need now is to go beyond observations. We need concrete solutions and large-scale collaborations.</p>
                  <p> Evi Lazou-Laskaridis, Chairman of Athanasios C. Laskaridis Charitable Foundation</p>
                </div>
              </SwiperSlide>
            </Swiper>
          </SwiperSlide>
        </Swiper>
      </div>
    </section>
  );
};

export default KeyMessages;
